export default __webpack_public_path__ + "static/media/5.006317dd.png";